import { render, staticRenderFns } from "./ChargeTypesPage.vue?vue&type=template&id=80b2d07a&scoped=true"
import script from "./ChargeTypesPage.vue?vue&type=script&lang=js"
export * from "./ChargeTypesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b2d07a",
  null
  
)

export default component.exports